import { computed } from 'vue'

const isMobile = computed(() => {
  return screen.width <= 600 ? true : false
})

export default isMobile
